import { Role } from "@/shared/types/role";

const ALL_ROLES = new Set<string>(Object.values(Role));

/**
 * Whitelist check against the `Role` enum. Anything that isn't exactly one of
 * the known role values (including unknown strings, numbers, null, undefined,
 * objects) becomes `null`. Used to narrow Firebase custom claims safely.
 */
export function parseRole(value: unknown): Role | null {
  if (typeof value !== "string") return null;
  return ALL_ROLES.has(value) ? (value as Role) : null;
}
